// src/lib/cache/recurringExpenses.js
//
// Per-entity cache wiring for recurring_expenses. Both create and update
// use useRefetchListMutation because the api functions return only { id }
// (no full row to reconcile). Settings-level list — round trip per save
// is fine. Delete is the standard optimistic-drop.

import {
  listRecurringExpenses,
  createRecurringExpense,
  updateRecurringExpense,
  deleteRecurringExpense,
} from '../api/financial/expenseManagement.js'
import {
  useEntityListQuery,
  useRefetchListMutation,
  useStandardDeleteMutation,
  unwrapList,
} from './entityCache.js'

const ENTITY = 'recurring_expenses'

export const useRecurringExpensesQuery = () =>
  useEntityListQuery(ENTITY, unwrapList('recurring expenses', () => listRecurringExpenses()))

export const useCreateRecurringExpenseMutation = () =>
  useRefetchListMutation(ENTITY, {
    mutationFn: (payload) => createRecurringExpense(payload),
  })

export const useUpdateRecurringExpenseMutation = () =>
  useRefetchListMutation(ENTITY, {
    mutationFn: ({ id, ...patch }) => updateRecurringExpense(id, patch),
  })

export const useDeleteRecurringExpenseMutation = () =>
  useStandardDeleteMutation(ENTITY, deleteRecurringExpense)
